/** Returns true when pathname matches any of the given path fragments. */
export const checkDisableNav = (pathName: string, listOfPaths: string[]): boolean => listOfPaths.some((path) => pathName.includes(path))
